import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'md:group-hover/tile:bg-bg-page flex h-[50px] cursor-pointer justify-between gap-4 rounded-full md:mb-[2px] md:pl-4',
    prices: 'items-end py-3',
    price: 'heading-m-bold md:heading-2xl',
    oldPrice: 'heading-xs md:heading-m',
    button: 'size-[50px] group-hover/tile:opacity-100 md:opacity-0'
  },
  variants: {
    null: {
      true: {
        base: 'cursor-default opacity-0'
      }
    },
    isInCart: {
      true: {
        button: 'md:opacity-100'
      }
    }
  },
  defaultVariants: {
    null: false,
    isInCart: false
  }
});
